import React from 'react';
import styles from './InfoCard.module.scss';

type InfoPair = {
  label: string;
  value: React.ReactNode;
};

type InfoRow = InfoPair[];

type InfoCardProps = {
  header?: React.ReactNode;
  rows: InfoRow[];
};

const InfoCard: React.FC<InfoCardProps> = ({ header, rows }) => (
  <div className={styles.infoCard}>
    {header && header}
    <dl className={styles.profileBody}>
      {rows.map((row, rowIndex) => (
        <div className={styles.row} key={rowIndex}>
          {row.map((pair, pairIndex) => (
            <React.Fragment key={pairIndex}>
              <dt>{pair.label}</dt>
              <dd>{pair.value}</dd>
            </React.Fragment>
          ))}
        </div>
      ))}
    </dl>
  </div>
);

export default InfoCard;
